import { http } from './http';

export interface Bookmark {
  time: number;
  type: 1 | 2;
  text: string;
}
export interface NoteResponse {
  rCode: number;
  data: {
    name: string;
    createTime: string;
    type: 1 | 2 | 3;
    urls: string[];
    summary: string;
    transcription: string;
    bookmark: Bookmark[];
  };
}

export const getNoteDetail = (code: string) =>
  http.get<NoteResponse>(`/shared/note/${code}`)

